<template>
  <app-layout>
   <div class="d-flex"> 
    <nav class="w-52 bg-white fixed left-0   min-h-screen   shadow-md">
      <ul class="flex flex-col items-center ">
       
          <jet-responsive-nav-link :active="route().current('tenant-admin-panels.users')" :href="'/tenant-admin-panels/users'"  class="  w-full  text-gray-700">
          <i class="fas fa-th mr-3"></i>
            <span class="link-label text active">User</span>
          </jet-responsive-nav-link>
        <!--  -->
          <jet-responsive-nav-link :active="route().current('tenant-admin-panels.roles')"  :href="'/tenant-admin-panels/roles'" class=" w-full   text-gray-400 ">
            <i class="fas fa-th mr-3"></i>
          <span class="link-label text">Roles</span>
          </jet-responsive-nav-link>

    <!--  -->
           <jet-responsive-nav-link :active="route().current('tenant-admin-panels.products')"  :href="'/tenant-admin-panels/products'" class=" w-full text-gray-400">
          <i class="fas fa-th mr-3"></i>
            <span class="link-label text">Products</span>
          </jet-responsive-nav-link>

        <!--  -->
          <jet-responsive-nav-link :active="route().current('tenant-admin-panels.subscriptions')"  :href="'/tenant-admin-panels/subscriptions'" class=" w-full text-gray-400">
          <i class="fas fa-th mr-3"></i>
            <span class="link-label text">Licenses</span>
          </jet-responsive-nav-link>
    
        <!--  -->
          <jet-responsive-nav-link :active="route().current('tenant-admin-panels.invoices')"  :href="'/tenant-admin-panels/invoices'"   class=" w-full text-gray-400">
          <i class="fas fa-th mr-3"></i>
          <span class="link-label text">Invoices</span>
          </jet-responsive-nav-link>
        <!--  -->
        
          <jet-responsive-nav-link :active="route().current('tenant-admin-panels.billingaccounts')"  :href="'/tenant-admin-panels/billingaccounts'"   class=" w-full text-gray-400">
          <i class="fas fa-th mr-3"></i>
        <span class="link-label text">Billing Accounts</span>
          </jet-responsive-nav-link>
  <!--  -->
       
          <jet-responsive-nav-link :active="route().current('tenant-admin-panels.orgprofile')"   :href="'/tenant-admin-panels/orgprofile'" class=" w-full text-gray-400  ">
          <i class="fas fa-th mr-3"></i>
            <span class="link-label text">Org Profile</span>
          </jet-responsive-nav-link>

           <!--  -->
       
        <jet-responsive-nav-link
      v-if="isConsoleRoute"
      :active="route().current('cnsl-branches.index')"
      :href="'/cnsl-branches'"
      class="w-full text-gray-400"
    >
      <i class="fas fa-th mr-3"></i>
      <span class="link-label text">Console Branch</span>
    </jet-responsive-nav-link>

    <!-- If not, show the other link -->
    <jet-responsive-nav-link
      v-else
      :active="route().current('branches.index')"
      :href="'/branches'"
      class="w-full text-gray-400"
    >
      <i class="fas fa-th mr-3"></i>
      <span class="link-label text">Branch</span>
    </jet-responsive-nav-link>
      
       
        <!--  -->
       
          <jet-responsive-nav-link href="#" class=" w-full text-gray-400  ">
          <i class="fas fa-th mr-3"></i>
            <span class="link-label text">Support</span>
          </jet-responsive-nav-link>
      
        <!--  -->
          <jet-responsive-nav-link :active="route().current('user-tenant-access-requests.index','admin')"  :href="'/admin/user-tenant-access-requests'"   class=" w-full text-gray-400">
          <i class="fas fa-th mr-3"></i>
            <span class="link-label text">User Requ</span>
          </jet-responsive-nav-link>
      
        <!--  -->  
        <jet-responsive-nav-link :active="route().current('tenant-admin-panels.EmployeeOnbord')" :href="'/admin/tenant-admin-panels/employeeOnboard'"   class=" w-full text-gray-400">
          <i class="fas fa-th mr-3"></i>
            <span class="link-label text">Employee Onboard</span>
          </jet-responsive-nav-link>
      </ul>
    </nav>
  <div class="main-content">
     <slot ></slot>   
  </div>
    </div>
  </app-layout>
</template>
<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
export default {
  props: {
   
  },
  components: {
    AppLayout,
    JetResponsiveNavLink,
  },
  data() {
    return {
     
    };
  },
  methods: {
   gotoUser(){
    //show alert on click 
    alert('User');
    
   }
  },
  mounted() {},
  computed: {
    isConsoleRoute() {
      // Check if the current route starts with 'console'
      return this.$route.path.startsWith('/console');
    },
  }
}
;
</script>
<style scoped>
body {
  /* min-height: 100vh; */
  background-color: #dbe3ff;
  padding: 40px;
}
html {
  font-family: Rubik !important;
}
a.act {
  color: black;
  font-weight: 300;
  background: #d4e2f1;
  /* background: #abffe3; */
}
a.act::after {
  content: "";
  height: 100%;
  position: absolute;
  left: 2px;
  top: 0;
  width: 4px;
  background-color: #2a59ff;
}
a:hover {
  /* background-color: #10b981; */
  color: black;
  text-decoration: none;
}
nav {
  transition: all 0.2s;
  /* border: 2px solid rgb(233, 233, 233); */
}
nav.expanded .link-label {
  display: none;
}
nav.expanded {
  width: 66px;
}
nav.expanded ul li {
  align-items: center;
  justify-content: center;
}
nav.expanded ul li a {
  align-items: center;
  justify-content: center;
}
nav.expanded ul li a svg {
  margin: 0;
}
/* main page */
.main-content {
  /* background-color: rgb(238, 236, 236); */
  /* width: calc(100% - 250px); */
  /* height: 80vh; */
  /* margin-left: 225px; */
  padding: 20px 30px;
}
.main-content .panel-wrapper {
  margin: 20px 0;
  box-shadow: 0px 1px 3px #777;
}
.main-content .panel-wrapper .panel-body {
  padding: 10px 10px;
  font-size: 80%;
}
@media only screen and (max-width: 420px) {
  .main-content {
    width: 100%;
    margin-left: 0;
    z-index: -1;
    position: relative;
  }
}
@media only screen and (max-width: 768px) {
  .main-content {
    width: 100%;
    margin-left: 0;
    z-index: -1;
    position: relative;
  }
}
</style>